import { Toaster } from 'gcs-common/design-system/ui/toaster';
import ApiProvider from 'gcs-common/provider/ApiProvider';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router';

import { createWebPersister } from '../../offline-settings/react-query-persister';
import router from '../../router/router';
// @ts-expect-error we don't have types for redux store yet
import store from '../../store';

// @ts-expect-error we don't have types for redux store yet
const beemStore = store;

const AppRoot = () => {
  const persister = createWebPersister();
  return (
    <>
      <Provider store={beemStore}>
        <ApiProvider persister={persister}>
          <Toaster />
          <RouterProvider router={router} />
        </ApiProvider>
      </Provider>
    </>
  );
};

export default AppRoot;
